import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useParams
} from "react-router-dom";
const People = ({uid}) => (
    

<div className="content" id ="content">
        <div className="panel-center">
            <div className="card">
              <div className="card-header">
                <p className="ar">[ People I know ]</p>
              </div>
              <div className="card-body">

                  {<Link to="/postpeople">
                    <button style={{width: '50%'}}>Add New People <i class="fa fa-eye" aria-hidden="true"></i> </button>
                  </Link>}
    
                <p>
                هذه الصفحة تضم قائمة بأكثر من <p style={{fontSize: 32}}>100</p>شخص ممن أعرفهم، تشمل أفراد العائلة، الأقارب، الزملاء، العملاء، والأصدقاء. ما يجمعهم جميعًا هو كونهم أشخاصًا رائعين ومميزين، ولكل منهم صفة فريدة تميزهم، قمت بكتابتها تحت أسمائهم.
                </p>
                
                <li>
                  <ol>1- العائلة</ol>
                  <ol>2- الاصدقاء</ol>
                  <ol>3- زملاء العمل</ol>
                </li>
                
              </div>
            </div>

            <div className="card">

                <div className="card-body">
                    <h2>1</h2>
                    <h2> خالد الخضير رحمه الله</h2>

                    <em>" قوة الارادة والحكمة الصامته "</em>       
                </div>

            </div>

          </div>


        <div className="panel-right">

        </div>
        <div className="panel-left">
          <div className="card">

          </div>
        </div>
      </div>
);

export default People;
